/* eslint-disable */
import * as util from "@/api/automation";

const state = {
    textReplyTagId:'',
    textReplyTagIdNotif:'',
    formParamTRSt: {
        header: {
            title: '',
            id: "",
            message: "",
            image_url: "",
            is_enable_attach_file: false,
            is_custom_url: false,
            message_type: "text",
        },
    },
    formParamQRSt: {
        header: {
            title: '',
            id: "",
            message: "",
            footer_message: "",
            image_url: "",
            footer_message_status: false,
            is_enable_attach_file: false,
            is_custom_url: false,
            message_type: "text",
            button_type: "button",
        },
        detail_button: [
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            }
        ],
    },
    isShowForm: false,
    formParamCustomRules: {
        header_id: "",
        button_type: '',
        button_response: '',
        detail_button: [
            {
                header_id: "",
                auto_reply_button_id: ""
            },
            {
                header_id: "",
                auto_reply_button_id: ""
            },
            {
                header_id: "",
                auto_reply_button_id: ""
            },
            {
                header_id: "",
                auto_reply_button_id: ""
            },
            {
                header_id: "",
                auto_reply_button_id: ""
            },
            {
                header_id: "",
                auto_reply_button_id: ""
            },
            {
                header_id: "",
                auto_reply_button_id: ""
            },
            {
                header_id: "",
                auto_reply_button_id: ""
            },
            {
                header_id: "",
                auto_reply_button_id: ""
            },
            {
                header_id: "",
                auto_reply_button_id: ""
            }
        ]
    },
    formParamLinkSt: {
        id: "",
        button_type: "call",
        button_title: "",
        button_text: "",
        button_response: ""
    },
    formParamSt: {
        id: "",
        button_title: "",
        button_text: "",
        button_response: ""
    },
    formParamSRSt: {
        header: {
            title: '',
            start_away_hour: '',
            start_away_minute: '',
            end_away_hour: '',
            end_away_minute: '',
            id: "",
            license_id: "",
            message: "",
            trigger_on: "all",
            trigger_on_some_type: "any",
            frequency_per_person: 15,
            is_enable_away_message: 0,
            is_enable_away_message_status: false,
            // is_enable_attach_file: false,
            message_away: "",
            footer_message: "",
            image_url: "",
            footer_message_status: false,
            // is_custom_url: false,
            is_enable_attach_file: false,
            is_custom_url: false,
            message_type: "text",
            button_type: "button",
            button_type_away_message: "button"


        },
        detail_button: [
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            }
        ],
        detail_button_away: [
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            },
            {
                auto_reply_button_id: ""
            }
        ],
        detail_some: [
            {
                select_variable: "conversation",
                condition: "start_with",
                text: ""
            }
        ],
        start_away: "19:00",
        end_away: "08:00"
    },
};

const mutations = {
    SET_formParamLinkSt: (state, value) => {
        state.formParamLinkSt = value
    },
    SET_isShowForm: (state, value) => {
        state.isShowForm = value
    },
    SET_formParamSt: (state, value) => {
        state.formParamSt = value
    },
    SET_formParamSRSt: (state, value) => {
        state.formParamSRSt = value
    },
    SET_formParamCustomRules: (state, value) => {
        state.formParamCustomRules = value
    },
    SET_formParamQRSt: (state, value) => {
        state.formParamQRSt = value
    },
    SET_formParamTRSt: (state, value) => {
        state.formParamTRSt = value
    },
    SET_textReplyTagId: (state, value) => {
        state.textReplyTagId = value
    },
    SET_textReplyTagIdNotif: (state, value) => {
        state.textReplyTagIdNotif = value
    },
};

const actions = {
    setTextReplyTagIdNotif({ commit }, data) {
        commit("SET_textReplyTagIdNotif", data);
    },
    setTextReplyTagId({ commit }, data) {
        commit("SET_textReplyTagId", data);
    },
    detailTextReplyForEdit({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailTextReplyForEdit(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteTextReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deleteTextReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailTextReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailTextReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateTextReplyPublish({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateTextReplyPublish(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateTextReplyDraft({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateTextReplyDraft(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listTextReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listTextReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listTextReplySilent({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listTextReplySilent(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storeTextReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeTextReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storeTextReplySilent({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeTextReplySilent(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamTRSt({ commit }, data) {
        commit("SET_formParamTRSt", data);
    },
    actionDraftTextReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionDraftTextReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionPublishTextReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionPublishTextReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionDeleteTextReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionDeleteTextReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    countPendingTransferSmartReply() {
        return new Promise((resolve, reject) => {
            util.countPendingTransferSmartReply().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteTransferAutoReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deleteTransferAutoReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    activatedTransferAutoReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.activatedTransferAutoReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailSmartReplyForEditTransfer({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailSmartReplyForEditTransfer(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    transferAutoReplyValidation({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.transferAutoReplyValidation(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    transferAutoReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.transferAutoReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionDraftQuickReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionDraftQuickReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionPublishQuickReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionPublishQuickReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionDeleteQuickReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionDeleteQuickReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionDeleteCustomRules({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionDeleteCustomRules(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionDeleteAutoReplyLink({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionDeleteAutoReplyLink(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionDeleteAutoReplyButton({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionDeleteAutoReplyButton(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionPublishSmartAutoReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionPublishSmartAutoReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionDeleteSmartAutoReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionDeleteSmartAutoReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionDraftSmartAutoReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionDraftSmartAutoReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storeQuickReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeQuickReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamQRSt({ commit }, data) {
        commit("SET_formParamQRSt", data);
    },
    detailQuickReplyForEdit({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailQuickReplyForEdit(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteQuickReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deleteQuickReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailQuickReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailQuickReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateQuickReplyPublish({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateQuickReplyPublish(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateQuickReplyDraft({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateQuickReplyDraft(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listQuickReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listQuickReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamLinkSt({ commit }, data) {
        commit("SET_formParamLinkSt", data);
    },
    storeReplyLink({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeReplyLink(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailReplyLink({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailReplyLink(params).then(response => {
                var { data } = response
                commit("SET_formParamLinkSt", data);

                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteReplyLink({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deleteReplyLink(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listReplyLink({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listReplyLink(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteCustomRules({ commit }, headerId) {
        return new Promise((resolve, reject) => {
            util.deleteCustomRules(headerId).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listCustomRules({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listCustomRules(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storeCustomRules({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeCustomRules(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailCustomRules({ commit }, headerId) {
        return new Promise((resolve, reject) => {
            util.detailCustomRules(headerId).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamCustomRules({ commit }, data) {
        commit("SET_formParamCustomRules", data);
    },
    detailSmartReplyForEdit({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailSmartReplyForEdit(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },

    deleteSmartReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deleteSmartReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteSmartReplySilent({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deleteSmartReplySilent(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailSmartReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailSmartReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateSmartReplyPublish({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateSmartReplyPublish(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateSmartReplyDraft({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateSmartReplyDraft(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storeSmartReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeSmartReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamSRSt({ commit }, data) {
        commit("SET_formParamSRSt", data);
    },
    listSmartReply({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listSmartReply(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storeAgentV2({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeAgentV2(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    activateAgentV2({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.activateAgentV2(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deactivateAgentV2({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deactivateAgentV2(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteAgentV2({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deleteAgentV2(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    startAgentV2Simulation({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.startAgentV2Simulation(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sendAgentV2Simulation({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.sendAgentV2Simulation(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    resetAgentV2Simulation({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.resetAgentV2Simulation(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listSmartReplyTransfer({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listSmartReplyTransfer(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamSt({ commit }, data) {
        commit("SET_formParamSt", data);
    },
    setIsShowForm({ commit }, data) {
        commit("SET_isShowForm", data);
    },
    storeReplyButtons({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeReplyButtons(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailReplyButtons({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailReplyButtons(params).then(response => {
                var { data } = response
                commit("SET_formParamSt", data);

                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteReplyButtons({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deleteReplyButtons(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listReplyButtons({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listReplyButtons(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listReplyButtonsTransfer({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listReplyButtonsTransfer(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/automation.js